import { z } from "zod";

// Schemas

export const TagSchema = z.object({
  id: z.string(),
  text: z.string(),
});
